import React from "react";
import { Table } from "reactstrap";

import ShellCard from "../../../../components/ShellCard";
import { AUTOPILOT_COLORS } from "../../../../components/autopilot/styles";

// Resumo por passo do Onboarding de Transportadora (PO1-3282, épico PO1-3279):
// cadastro → contatos → homologação → pastas → acesso_sftp → email → portal.
// Antes (PO1-2161) o motor tinha só cadastro/pastas/acesso_sftp/email; os
// rótulos antigos continuam válidos.

const PASSO = {
  cadastro: "Cadastro e vínculo",
  contatos: "Contatos (TI, logística, cotação)",
  homologacao: "Homologação da transportadora",
  pastas: "Pastas e Local Arquivo",
  acesso_sftp: "Usuário no Wing FTP",
  email: "E-mail de aviso",
  portal: "Acesso ao portal (MeuFrete)",
};

const STATUS = {
  criado: { rotulo: "Criado", cor: AUTOPILOT_COLORS.statusSuccess },
  ja_existia: { rotulo: "Já existia", cor: AUTOPILOT_COLORS.statusInfo },
  reativado: { rotulo: "Reativado", cor: AUTOPILOT_COLORS.statusSuccess },
  legado: { rotulo: "Já existia (legado)", cor: AUTOPILOT_COLORS.statusWarning },
  pendente: { rotulo: "Pendente", cor: AUTOPILOT_COLORS.statusWarning },
  aguardando: { rotulo: "Aguardando", cor: AUTOPILOT_COLORS.statusWarning },
  pulado: { rotulo: "Pulado", cor: AUTOPILOT_COLORS.muted },
  curadoria: { rotulo: "Curadoria", cor: AUTOPILOT_COLORS.statusWarning },
  falhou: { rotulo: "Falhou", cor: AUTOPILOT_COLORS.statusDanger },
  erro: { rotulo: "Erro", cor: AUTOPILOT_COLORS.statusDanger },
};

const DETALHE = {
  legado: "Usuário antigo na pasta do vínculo: nada foi criado. Senha só pelo botão Gerar nova senha.",
  passo_anterior_falhou: "Não rodou porque o passo anterior falhou. Reexecute depois de corrigir.",
  modo_ate_pastas: "Modo até pastas: acesso e e-mail ficam para depois.",
  sftp_acesso_desabilitado: "Motor de acesso desligado neste ambiente (SFTP_ACESSO_ENABLED).",
  sftp_indisponivel: "Linhas gravadas, mas o SFTP não respondeu. Reexecute.",
  resultado_incerto: "O Wing FTP não confirmou. Reexecutar resolve pela leitura.",
  operacao_em_andamento: "Outra operação em andamento neste vínculo.",
  sem_destinatario: "Nenhum e-mail de destino.",
  email_ja_enviado: "O aviso já tinha sido enviado.",
  email_falhou: "O SMTP falhou; o acesso ficou criado. Reenvie reexecutando.",
  usuario_recriado: "O usuário tinha sumido do Wing e foi recriado com a senha guardada.",
  apelido_pendente: "Apelido pendente de revisão: confira o apelido quando puder. Não trava o onboarding.",
  vinculo_inativo: "Vínculo inativo: marque Religar o vínculo.",
  raiz_divergente: "Linhas com raízes diferentes; corrija no banco.",
  acesso_revogado: "Acesso revogado; não é reprovisionado.",
  // PO1-3282
  transportadora_criada: "Transportadora cadastrada na matriz (0001) pela Receita e vinculada.",
  vinculo_criado: "Transportadora já existia; o vínculo com o embarcador foi criado.",
  vinculo_ativo: "Transportadora e vínculo já existiam.",
  curadoria: "Foi para a Curadoria da Everlog (matriz 0001 precisa de ajuste). O onboarding segue quando liberar.",
  transportadora_nao_cadastrada: "CNPJ não cadastrado e sem dados na Receita.",
  sem_contatos: "Nenhum contato informado.",
  aguardando_homologacao: "Transportadora nova na Rede: aprove na fila de Homologação para pastas e acesso seguirem.",
  devolvido: "A homologação foi devolvida; reenvie depois de corrigir.",
  transportadora_homologada: "Transportadora já homologada: o onboarding segue direto.",
  sem_habilitacao: "Vínculo sem habilitação; abra o onboarding de novo.",
  login_ativo_aviso_enviado: "A transportadora já acessa o portal; o embarcador entrou no escopo dela e ela recebeu aviso.",
  convite_aberto: "Já havia convite em aberto para esta transportadora.",
  sem_email_para_convite: "Sem e-mail para o convite do portal: cadastre o contato de TI.",
  sem_acao: "Nenhuma ação necessária no portal.",
};

// Detalhes com sufixo variável (ex.: convite_123).
function descreverDetalhe(d) {
  if (!d) return "";
  if (DETALHE[d]) return DETALHE[d];
  if (/^convite_/.test(d)) return "Convite para criar o acesso ao portal enviado.";
  if (/^status_/.test(d)) return `Pulado: o vínculo está em ${d.replace("status_", "").toUpperCase()}.`;
  return d;
}

function Tabela({ passos }) {
  return (
    <Table responsive className="hub-thead-accent" style={{ marginBottom: 0 }}>
      <thead>
        <tr>
          <th>Passo</th>
          <th>Status</th>
          <th>Detalhe</th>
        </tr>
      </thead>
      <tbody>
        {passos.map((p, i) => {
          const s = STATUS[p.status] || { rotulo: p.status, cor: AUTOPILOT_COLORS.text };
          return (
            <tr key={`${p.passo}-${i}`}>
              <td style={{ color: AUTOPILOT_COLORS.title }}>{PASSO[p.passo] || p.passo}</td>
              <td style={{ color: s.cor, fontWeight: 600 }}>{s.rotulo}</td>
              <td style={{ color: AUTOPILOT_COLORS.textSoft, fontSize: "0.84rem" }}>{descreverDetalhe(p.detalhe)}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

const ESTADO_TITULO = {
  OPERACIONAL: "Onboarding concluído: transportadora operacional",
  EM_ONBOARDING: "Onboarding em andamento",
  AGUARDANDO_HOMOLOGACAO: "Aguardando homologação da Everlog",
  EM_CONFIGURACAO: "Aguardando homologação da Everlog",
  DEVOLVIDO: "Homologação devolvida",
  EM_CURADORIA: "Foi para a Curadoria da Everlog",
  NAO_CADASTRADA: "Transportadora não cadastrada",
};

// `embutido`: só a tabela, para quem já está dentro de um card.
export default function ResultadoPassos({ resultado, embutido }) {
  const passos = (resultado && resultado.passos) || [];
  if (embutido) return <Tabela passos={passos} />;
  const estado = resultado && resultado.estado;
  const titulo = (estado && ESTADO_TITULO[estado]) || (resultado && resultado.ok ? "Provisionamento concluído" : "Provisionamento com pendência");
  const descricao = [];
  if (resultado && resultado.acesso && resultado.acesso.usuario) descricao.push(`Usuário: ${resultado.acesso.usuario}`);
  if (resultado && resultado.emAndamento) descricao.push("Pastas, usuário SFTP, e-mail e portal continuam depois da resposta: atualize em instantes.");
  if (estado === "EM_CURADORIA" && resultado.curadoria && resultado.curadoria.motivo) descricao.push(`Motivo: ${resultado.curadoria.motivo}`);
  return (
    <ShellCard eyebrow="Resultado" title={titulo} description={descricao.length ? descricao.join(" · ") : undefined} style={{ marginTop: "1rem" }}>
      <Tabela passos={passos} />
    </ShellCard>
  );
}
